
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eagleshare-privacy-policy",
      function () {
        return require("private-next-pages/eagleshare-privacy-policy.js");
      }
    ]);
  